<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      isRouterAlive: true,
      windowWidth: '',
      windowHeight: '',
      isSideBarShow: true,
      timer: null,
      flag: true,
    }
  },
  mounted() {
    // window.addEventListener('resize', this.reload)
  },
  created() {
    // window.onresize = function () {
    //   this.resetFontSize()
    // }
    const deviceStr = this.getExploreName()
    this.$store.commit('process/app/setDeviceInfo', deviceStr)
    
  },
  methods: {
    // 获取浏览器信息
    getExploreName() {
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        return 'Opera'
      } else if (
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1
      ) {
        return 'IE'
      } else if (userAgent.indexOf('Edge') > -1) {
        return 'Edge'
      } else if (userAgent.indexOf('Firefox') > -1) {
        return 'Firefox'
      } else if (
        userAgent.indexOf('Safari') > -1 &&
        userAgent.indexOf('Chrome') == -1
      ) {
        return 'Safari'
      } else if (
        userAgent.indexOf('Chrome') > -1 &&
        userAgent.indexOf('Safari') > -1
      ) {
        return 'Chrome'
      } else if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return 'IE>=11'
      } else {
        return 'pcUnkonwn'
      }
    },
    reload() {
      if (this.flag == true) {
        //如果节流阀开启状态就执行if语句里面的代码

        //开始工作关闭节流阀
        this.flag = false

        this.timer = setTimeout(() => {
          // console.log('重置')
          this.isRouterAlive = false //先关闭，
          this.$nextTick(() => {
            this.isRouterAlive = true //再打开
            console.log('this.', this.windowWidth)
          })
          this.flag = true //工作结束开启节流阀方便下一个工作
        }, 500)
      }
    },
  },
}
</script>

<style>
html,
body,
#app {
  zoom: 1;
  min-width: 1400px !important;
  overflow-x: auto;
  /* font-family: Microsoft YaHei !important; */
  /* font-family: Heiti SC !important; */
  /* font-family: 'Tahoma' !important; */
}
.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
:focus {
  outline: 0;
}
.el-checkbox ::after {
  transition: none !important;
}
.el-tooltip__popper.is-dark {
  background: rgb(39, 71, 93) !important;
  opacity: 0.8;
}
::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

/* *在Chrome下移除input[number]的上下箭头* */
::-webkit-outer-spin-button,
::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none !important;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none !important;
}

/*在firefox下移除input[number]的上下箭头*/
 {
  -moz-appearance: textfield;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* 图片预览背景遮罩层 */
.viewer-backdrop {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
@media print {
  @page {
    size: auto;
  }
  body,
  html {
    height: auto !important;
  }
}
</style>
